const backend_url = "https://tourism-website-backend-p8h2.onrender.com";
export default backend_url;

export const razorkey_id = "rzp_test_RfA1p0DJC2RGk4";